import styled from 'styled-components';

import { Button } from 'components/Button';
import { getDimension } from 'styled/helpers/getDimension';

export const MenuButton = styled(Button)`
  height: auto;
  padding: ${getDimension('size4')};
`;
